import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const links = ['SERVICES', 'GALLERY', 'ABOUT', 'REVIEWS'];
  return <nav className={`fixed top-0 z-40 w-full transition-all duration-300 ${scrolled ? 'bg-otter-black/95 py-2 shadow-[0_4px_30px_rgba(59,180,224,0.1)] backdrop-blur-sm' : 'bg-transparent py-4'}`} data-id="element-242">
      <div className="container mx-auto flex items-center justify-between px-4 md:px-8" data-id="element-243">
        {/* Logo */}
        <div className="flex items-center gap-3" data-id="element-244">
          <img src="https://cdn.magicpatterns.com/uploads/4HX4fnnnRHUFQ1DwVQMuBe/37.png" alt="Otter Grill Cleaning Logo" className="h-12 w-12 rounded-full border-2 border-otter-cyan bg-otter-black object-cover" data-id="element-245" />
          <span className="hidden font-display text-2xl tracking-widest text-otter-cyan sm:block" data-id="element-246">
            OTTER
          </span>
        </div>

        {/* Desktop Links */}
        <div className="hidden items-center gap-8 md:flex" data-id="element-247">
          {links.map(link => <a key={link} href={`#${link.toLowerCase()}`} className="font-display text-lg tracking-wider text-otter-bone transition-colors hover:text-otter-cyan" data-id="element-248">
              {link}
            </a>)}
        </div>

        {/* CTA & Mobile Toggle */}
        <div className="flex items-center gap-4" data-id="element-249">
          <a href="#contact" className="hidden border-2 border-otter-cyan bg-otter-cyan px-6 py-2 font-display text-xl tracking-wider text-otter-black transition-all hover:-translate-y-1 hover:shadow-brutal-cyan md:block" data-id="element-250">
            BOOK NOW
          </a>
          <button className="text-otter-cyan md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-251">
            {mobileMenuOpen ? <X size={32} data-id="element-252" /> : <Menu size={32} data-id="element-253" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="absolute left-0 top-full w-full border-b-4 border-otter-cyan bg-otter-black p-4 md:hidden" data-id="element-254">
          <div className="flex flex-col gap-4 text-center" data-id="element-255">
            {links.map(link => <a key={link} href={`#${link.toLowerCase()}`} className="font-display text-2xl tracking-wider text-otter-bone hover:text-otter-cyan" onClick={() => setMobileMenuOpen(false)} data-id="element-256">
                {link}
              </a>)}
            <a href="#contact" className="mt-4 border-2 border-otter-cyan bg-otter-cyan px-6 py-3 font-display text-2xl tracking-wider text-otter-black" onClick={() => setMobileMenuOpen(false)} data-id="element-257">
              BOOK NOW
            </a>
          </div>
        </div>}
    </nav>;
}